import { CATALOG_CATALOG_FREE_INDEX_SET_DATA } from 'rebook/apps/catalog/constants';


const initialState = {
  niches: null,
};

export default function catalogFreeIndex(state = initialState, action) {
  switch (action.type) {
    case CATALOG_CATALOG_FREE_INDEX_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
